<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-03-31 11:48:32
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-04-15 13:53:03
-->
<template>
	<span class="el-dropdown-link flex-row flex-align-center" v-if="!notSingleVersion">
		<i class="mr-4" :class="item" v-for="item in iconList" :key="item"></i>
		{{ currentPlatform.label }}
	</span>
	<el-dropdown @command="click" v-else>
		<span class="el-dropdown-link flex-row flex-align-center">
			<i class="mr-4" :class="item" v-for="item in iconList" :key="item"></i>
			{{ currentPlatform.label }}<i class="el-icon-caret-bottom el-icon--right"></i>
		</span>
		<el-dropdown-menu slot="dropdown">
			<el-dropdown-item :icon="(item.value && item.icon[0]) || ''" v-for="item in platformList" :key="item.value" :command="+item.value">{{
				item.label
			}}</el-dropdown-item>
		</el-dropdown-menu>
	</el-dropdown>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
	data() {
		return {
			current: 0,
		};
	},
	mounted() {
		this.initCurrent();
	},
	watch: {
		notSingleVersion() {
			this.initCurrent();
		},
		defaultPlatform() {
			this.initCurrent();
		},
	},
	computed: {
		...mapGetters(['canShowPlatformList', 'notSingleVersion', 'defaultPlatform']),
		platformList() {
			const _list = this.canShowPlatformList.map(item => ({ ...item, icon: [item?.icon] }));
			const icon = this.canShowPlatformList.map(item => item.icon);
			return this.notSingleVersion ? [{ label: '全部平台', value: 0, icon }, ..._list] : _list;
		},
		currentPlatform() {
			return this.platformList.find(item => +item.value === this.current) || {};
		},
		iconList() {
			return this.currentPlatform?.icon || [];
		},
	},
	methods: {
		click(val) {
			this.current = val;
			this.$emit('change', val);
		},
		getPlatform() {
			return this.current;
		},
		initCurrent() {
			this.current = this.notSingleVersion ? 0 : +this.defaultPlatform;
		},
	},
};
</script>